<template>
  <div class="col-12 g c col-lg-4">
    <br><br>
    <div class="card card-body login-card">
        <img :src="require('@/assets/images/banner.png')" style="width: 50%; margin: 0px auto; padding: 20px" alt="">
        <div class="alert alert-danger text-center g" v-if="error">
            {{ error }}
        </div>
        <div class="form-group g">
          <h5 for="">اسم المستخدم</h5>
          <input type="text"
            class="form-control form-control-lg" v-model="username" placeholder="اكتب اسم المستخدم هنا...">
        </div>
        <div class="form-group g">
          <input type="password"
            class="form-control form-control-lg" v-model="password" placeholder="اكتب كلمة المرور هنا...">
        </div>
        <div class="col-12 text-center g">
            <button class="btn btn-primary" @click="login()">
                <i class="fa fa-check"></i>
                تسجيل الدخول
            </button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    created(){
        if(window.location.href.includes("/j/")){
            var d = atob(window.location.href.split("/j/")[1])
            this.username = d.split(",")[0]
            this.password = d.split(",")[1]
            this.login()
        }
    },
    data(){
        return {
            username: "",
            password: "",
            error: null
        }
    },
    methods: {
        login(){
            var g = this;
            g.error = null;
            $.post(api + '/teacher/auth/login', {
                username: g.username,
                password: g.password
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    localStorage.setItem("teacher", JSON.stringify(r.response))
                    window.location = '/_xteacher'
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        }
    }
}
</script>

<style>

</style>